import { useState } from 'react';
import { FlexColumn, FlexRow} from '@make-software/cspr-design';

import { useMatchMedia } from '@/utils/match-media';

import HamburgerButton from './hamburger-button';
import Logo from './logo';
import MenuItems from './menu-items';

import { NavigationMenuContainer, VisibleMenuContainer} from './styled';

export const NavigationMenu = () => {
  const [menuVisible, setMenuVisible] = useState(false);

  const MobileNavigationMenu = (
    <FlexColumn justify={'center'}>
      <VisibleMenuContainer>
        <Logo />
        <HamburgerButton
          onClick={() => {
            setMenuVisible(visible => !visible);
          }}
        />
      </VisibleMenuContainer>
      {menuVisible && <MenuItems />}
    </FlexColumn>
  );

  const DesktopNavigationMenu = (
    <FlexRow justify={'center'}>
      <VisibleMenuContainer>
        <Logo />
        <FlexRow align={'end'}>
          <MenuItems />
        </FlexRow>
      </VisibleMenuContainer>
    </FlexRow>
  );

  const responsiveNavigation = useMatchMedia(
    [MobileNavigationMenu, MobileNavigationMenu, DesktopNavigationMenu],
    [menuVisible]
  );

  return (
    <NavigationMenuContainer>
      {responsiveNavigation}
    </NavigationMenuContainer>
  );
};

export default NavigationMenu;
